import store from "@src/reducers/store";
import { deleteNodesFromNodeset } from "../delete-nodes-from-nodeset";
import { updateDataAcquisitionBulkEditIconState } from "../find-selected-nodes-with-data-acquisition-type-attribute-and-manage-bulk-icon";
import {
  countCheckedNodes,
  updateInitialListAndFilteredInitialListWithSelectedNode,
  updateMachineStructureListAndFilteredMachineStructureListWithSelectedNode,
} from "../update-lists-with-selected-node";
import {
  emptyAlarmNodeData,
  emptyNodeDataObject,
  NodeManagerActiveViewType,
  updateActiveViewUnsavedStructureForNodeManagerNavigationModal,
  updateActiveViewUnsavedConditionMonitoringForNodeManagerNavigationModal,
  updateAlarmNodeSelectionData,
  updateAlarmNodeSelectionState,
  updateEditStructurePageInitialDataFiltered,
  updateEditStructurePageTransferDataFiltered,
  updateInitialFilterModalFilterInputContent,
  updateMachineStructureFilterModalFilterInputContent,
  updateNodeManagerActiveView,
  updateNodeSelectionNodeData,
  updateNodeSelectionNodeEditedState,
  updateNodeSelectionState,
  updateShowInitialFilterModal,
  updateShowMachineStructureFilterModal,
  updateShowUnsavedStructureForNodeManagerNavigationModal,
  updateShowUnsavedConditionMonitoringForNodeManagerNavigationModal,
  updateShowUnsavedStructureModal,
} from "@src/reducers/your-reducer";
import clearInitialAndMachineStructure from "../clear-initial-and-machine-structures";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import { InitialCheckBoxClickHandler } from "./initial-checkbox-click-handler";
import { MachineCheckBoxClickHandler } from "./machine-checkbox-click-handler";
import { InitialCaretClickHandler } from "./initial-caret-click-handler";
import { MachineCaretClickHandler } from "./machine-caret-click-handler";
import {
  loadMachineStructureAndDashboards,
  loadInitialStructureAsyncInBackground,
} from "../load-our-node-structures";
import { MachineCreateFolderHandler } from "./machine-create-folder-handler";
import { MachineSaveNodeNameHandler } from "./machine-save-node-name-handler";
import { MachineDeleteNodesFromNodesetHandler } from "./machine-delete-nodes-from-nodeset-handler";
import { MachineDeleteNodeFromSidePanelHandler } from "./machine-delete-node-from-side-panel-handler";
import { InitialToMachineStructureDragAndDropHandler } from "./initial-to-machine-drag-and-drop-handler";
import { MachineToMachineStructureDragAndDropHandler } from "./machine-to-machine-drag-and-drop-handler";
import { InitialToMachineStructurFolderDragAndDropHandler } from "./initial-to-machine-drag-and-drop-in-folder-handler";
import { MachineToMachineStructurFolderDragAndDropHandler } from "./machine-to-machine-drag-and-drop-in-folder-handler";
import { TransferSelectedNodesToMachineStructureHandler } from "./transfer-selected-nodes-to-machine-structure-handler";
import { MachineSaveNodeDataInPanelHandler } from "./machine-save-node-data-in-panel-handler";
import { MachineWriteDataAcquisitionTypeOnSelectedNodesHandler } from "./machine-write-data-acquisition-type-on-selected-nodes-handler";
import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { filterInitialStructureNew } from "./filter-initial-structure-new";
import { filterMachineStructureNew } from "./filter-machine-structure-new";
import {
  getAlarmProfiles,
  getAlarmProfilesReferenceCopy,
} from "@src/cloud-connect/dependency-injection-container/get-alarm-profiles";
import { obtainReactRouteFromUrl } from "@src/cloud-connect/utils/obtain-react-route-from-url";

export class NodeManager {
  public getInitialCheckBoxClickHandler() {
    return new InitialCheckBoxClickHandler();
  }

  public getMachineCheckBoxClickHandler() {
    return new MachineCheckBoxClickHandler();
  }

  public getInitialCaretClickHandler() {
    return new InitialCaretClickHandler();
  }

  public getMachineCaretClickHandler() {
    return new MachineCaretClickHandler();
  }

  public getCreateFolderHandler() {
    return new MachineCreateFolderHandler();
  }

  public getSaveNodeNameHandler() {
    return new MachineSaveNodeNameHandler();
  }

  public getSaveNodeDataInPanelHandler() {
    return new MachineSaveNodeDataInPanelHandler();
  }

  public getWriteDataAcquisitionTypeOnSelectedNodesHandler() {
    return new MachineWriteDataAcquisitionTypeOnSelectedNodesHandler();
  }

  public deleteNodesFromNodesetHandler() {
    return new MachineDeleteNodesFromNodesetHandler();
  }

  public deleteNodesFromSidePanelHandler() {
    return new MachineDeleteNodeFromSidePanelHandler();
  }

  public initialToMachineStructureDragAndDropHandler() {
    return new InitialToMachineStructureDragAndDropHandler();
  }

  public initialToMachineStructureFolderDragAndDropHandler() {
    return new InitialToMachineStructurFolderDragAndDropHandler();
  }

  public machineToMachineStructureDragAndDropHandler() {
    return new MachineToMachineStructureDragAndDropHandler();
  }

  public machineToMachineStructureFolderDragAndDropHandler() {
    return new MachineToMachineStructurFolderDragAndDropHandler();
  }

  public transferSelectedNodesToMachineStructureHandler() {
    return new TransferSelectedNodesToMachineStructureHandler();
  }

  public updateInitialListAndFilteredInitialListWithSelectedNode(node) {
    updateInitialListAndFilteredInitialListWithSelectedNode(node);
  }

  public updateMachineStructureListAndFilteredMachineStructureListWithSelectedNode(
    node,
  ) {
    updateMachineStructureListAndFilteredMachineStructureListWithSelectedNode(
      node,
    );
  }

  public updateDataAcquisitionBulkEditIconState() {
    updateDataAcquisitionBulkEditIconState();
  }

  public countCheckedNodes(item) {
    return countCheckedNodes(item);
  }

  public deleteNodesFromNodeset(
    transferedNodeData,
    filteredTransferedNodeData,
  ) {
    return deleteNodesFromNodeset(
      transferedNodeData,
      filteredTransferedNodeData,
    );
  }

  public closeNodeManagerDetailsPanel() {
    store.dispatch(updateNodeSelectionNodeEditedState(false));
    store.dispatch(updateNodeSelectionNodeData(emptyNodeDataObject));
    store.dispatch(updateNodeSelectionState("none"));
  }

  /** Inital Structure Filter Modal Start */

  public closeInitialStructureFilterModal() {
    store.dispatch(updateShowInitialFilterModal(false));
  }

  public handleClearFilterClickInInitialFilterModal() {
    this.closeInitialStructureFilterModal();
    store.dispatch(updateInitialFilterModalFilterInputContent(undefined));
    store.dispatch(updateEditStructurePageInitialDataFiltered(undefined));
  }

  public handleClearNewFilterClickInInitialFilterModal() {
    getLogger().debug("NodeManager", {
      function: "handleClearNewFilterClickInInitialFilterModal",
    });
    this.closeInitialStructureFilterModal();
    store.dispatch(updateInitialFilterModalFilterInputContent(undefined));

    const initialStructureNodeset = getInitialStructureNodeset();
    initialStructureNodeset.setFilteredFlatMap(new Map());
    initialStructureNodeset.setShowFilterPanel(false);
  }

  public writeFilterInputContentToStoreInInitialFilterModal(input) {
    store.dispatch(updateInitialFilterModalFilterInputContent(input));
  }

  public handleShowResultsClickInInitialFilterModal(filterInputContent) {
    getLogger().debug("NodeManager", {
      function: "handleShowResultsClickInInitialFilterModal",
    });
    filterInitialStructureNew(filterInputContent);
  }

  /** Inital Structure Filter Modal End */

  /** Inital Structure Filter Modal Start */
  public closeMachineStructureFilterModal() {
    getLogger().debug("NodeManager", {
      function: "closeMachineStructureFilterModal",
    });
    store.dispatch(updateShowMachineStructureFilterModal(false));
  }

  public handleClearFilterClickInMachineFilterModal() {
    this.closeMachineStructureFilterModal();
    store.dispatch(
      updateMachineStructureFilterModalFilterInputContent(undefined),
    );
    store.dispatch(updateEditStructurePageTransferDataFiltered(undefined));
  }

  public handleClearNewFilterClickInMachineFilterModal() {
    getLogger().debug("NodeManager", {
      function: "handleClearNewFilterClickInMachineFilterModal",
    });
    this.closeMachineStructureFilterModal();
    store.dispatch(
      updateMachineStructureFilterModalFilterInputContent(undefined),
    );

    const machineStructureNodeset = getMachineStructureNodeset();
    machineStructureNodeset.setFilteredFlatMap(new Map());
    machineStructureNodeset.setShowFilterPanel(false);
  }

  public writeFilterInputContentToStoreInMachineFilterModal = (input) => {
    store.dispatch(updateMachineStructureFilterModalFilterInputContent(input));
  };

  public handleShowResultsClickInMachineFilterModal(filterInputContent) {
    getLogger().debug("NodeManager", {
      function: "handleShowResultsClickInMachineFilterModal",
    });
    filterMachineStructureNew(filterInputContent);
  }

  /** Inital Structure Filter Modal End */

  /** flat-edit-strcutre-page-hook Start */

  /**
   * Phase 1 of loading: Loads only machine structure (saved structure by client) + dashboards
   * This allows the UI to render quickly with the machine structure data
   * while the initial structure loads in the background.
   *
   * @returns Promise that resolves to the saved structure with keys
   */
  public async loadMachineStructureAndDashboards(signal: AbortSignal) {
    return loadMachineStructureAndDashboards(signal);
  }

  /**
   * Phase 2 of loading: Loads the initial structure asynchronously in the background.
   * Does NOT block the UI. Components automatically update via the observer pattern when
   * the initialStructureNodeset is populated.
   *
   * Call this after loadMachineStructureAndDashboards() completes. It can be awaited or left as a
   * background task (fire-and-forget).
   *
   * @param savedStructureWithKeys Optional: the result from loadMachineStructureAndDashboards for merging names
   */
  public async loadInitialStructureAsyncInBackground(
    savedStructureWithKeys?: any,
    signal?: AbortSignal,
  ) {
    return loadInitialStructureAsyncInBackground(
      savedStructureWithKeys,
      signal,
    );
  }

  /** flat-edit-strcutre-page-hook End */

  /** initial structure new filter Start */
  public handleClickNewFilterInitial() {
    getLogger().debug("NodeManager", {
      function: "handleClickNewFilterInitial",
    });
    store.dispatch(updateShowInitialFilterModal(true));
  }

  public clearFilterNewForInitialList() {
    getLogger().debug("NodeManager", {
      function: "clearFilterNewForInitialList",
    });
    // store.dispatch(updateEditStructurePageInitialDataFiltered(undefined));
    const initialStructureNodeset = getInitialStructureNodeset();
    initialStructureNodeset.setFilteredFlatMap(new Map());
    initialStructureNodeset.setShowFilterPanel(false);

    store.dispatch(updateInitialFilterModalFilterInputContent(""));
  }
  /** initial structure filter End */

  /** initial structure filter Start */
  public handleClickFilterInitial() {
    store.dispatch(updateShowInitialFilterModal(true));
  }

  public clearFilterForInitialList() {
    store.dispatch(updateEditStructurePageInitialDataFiltered(undefined));
    store.dispatch(updateInitialFilterModalFilterInputContent(""));
  }
  /** initial structure filter End */

  /** machine structure filter Start */
  public handleClickFilterMachineStructure() {
    getLogger().debug("NodeManager", {
      function: "handleClickFilterMachineStructure",
    });
    store.dispatch(updateShowMachineStructureFilterModal(true));
  }

  public clearFilterForMachineStructureList() {
    store.dispatch(updateEditStructurePageTransferDataFiltered(undefined));
    store.dispatch(updateMachineStructureFilterModalFilterInputContent(""));
  }

  public clearFilterForNewMachineStructureList() {
    getLogger().debug("NodeManager", {
      function: "clearFilterForNewMachineStructureList",
    });
    const machineStructureNodeset = getMachineStructureNodeset();
    machineStructureNodeset.setFilteredFlatMap(new Map());
    machineStructureNodeset.setShowFilterPanel(false);

    store.dispatch(updateMachineStructureFilterModalFilterInputContent(""));
  }
  /** machine structure filter End */

  /** back to sources list Start */

  public flushAlarmRowSidePanelInfo = () => {
    store.dispatch(updateAlarmNodeSelectionState("none"));
    store.dispatch(updateAlarmNodeSelectionData(emptyAlarmNodeData));
  };

  private getRouteToReturnFromNodeManager = (): Route | string => {
    const searchParams = new URLSearchParams(window.location.search);
    const origin = searchParams.get("origin") || searchParams.get("from") || "";
    const gatewayUuid = searchParams.get("gateway_uuid")?.trim() || "";

    if (origin === "gateways") {
      return gatewayUuid
        ? `${Route.GATEWAYS}?gateway_uuid=${encodeURIComponent(gatewayUuid)}`
        : Route.GATEWAYS;
    }

    return Route.MACHINES;
  };

  public performChangesCheckWhenNavigatingAwayFromNodeManager = (route) => {
    const structureWasSaved = store.getState().yourSlice.structureWasSaved;

    const isConditionMonitoringEqual =
      this.isAlarmProfilesReferenceCopyEqualToAlarmProfiles();

    const updateDuplicateStructureIds =
      store.getState().yourSlice.duplicateStructureIds;

    if (
      (structureWasSaved && isConditionMonitoringEqual) ||
      getMachineStructureNodeset().getFlatMap().size <= 1 ||
      updateDuplicateStructureIds.length > 0
    ) {
      const routeToNavigate = obtainReactRouteFromUrl(route);
      navigateTo(routeToNavigate);

      clearInitialAndMachineStructure();
      this.flushAlarmRowSidePanelInfo();

      const alarmProfiles = getAlarmProfiles();
      alarmProfiles.setAlarmProfiles([]);

      const alarmProfilesReferenceCopy = getAlarmProfilesReferenceCopy();
      alarmProfilesReferenceCopy.setAlarmProfiles([]);

      store.dispatch(updateNodeManagerActiveView("treeStructure"));
    } else {
      if (getMachineStructureNodeset().getFlatMap().size > 1) {
        const routeToNavigate = obtainReactRouteFromUrl(route);
        store.dispatch(
          updateShowUnsavedStructureModal({
            showUnsavedStructureModal: true,
            routeToNavigateAfterConfirmation: routeToNavigate,
          }),
        );
      }
    }
  };

  public backToSourcesListSetNavPillToTreeStructureDefault = () => {
    const routeToNavigate = this.getRouteToReturnFromNodeManager();
    const structureWasSaved = store.getState().yourSlice.structureWasSaved;

    const isConditionMonitoringEqual =
      this.isAlarmProfilesReferenceCopyEqualToAlarmProfiles();

    const updateDuplicateStructureIds =
      store.getState().yourSlice.duplicateStructureIds;

    if (
      (structureWasSaved && isConditionMonitoringEqual) ||
      getMachineStructureNodeset().getFlatMap().size <= 1 ||
      updateDuplicateStructureIds.length > 0
    ) {
      navigateTo(routeToNavigate);
      clearInitialAndMachineStructure();
      this.flushAlarmRowSidePanelInfo();

      const alarmProfiles = getAlarmProfiles();
      alarmProfiles.setAlarmProfiles([]);

      const alarmProfilesReferenceCopy = getAlarmProfilesReferenceCopy();
      alarmProfilesReferenceCopy.setAlarmProfiles([]);

      store.dispatch(updateNodeManagerActiveView("treeStructure"));
    } else {
      if (getMachineStructureNodeset().getFlatMap().size > 1) {
        store.dispatch(
          updateShowUnsavedStructureModal({
            showUnsavedStructureModal: true,
            routeToNavigateAfterConfirmation: routeToNavigate,
          }),
        );
      }
    }
  };

  checkIfStructureIsSavedOrEmptyAndNavigateOrOpenUnsavedStructureModal = (
    activeView,
  ) => {
    const structureWasSaved = store.getState().yourSlice.structureWasSaved;
    if (
      structureWasSaved ||
      getMachineStructureNodeset().getFlatMap().size <= 1
    ) {
      this.flushAlarmRowSidePanelInfo();
      store.dispatch(updateNodeManagerActiveView(activeView));
    } else {
      store.dispatch(
        updateActiveViewUnsavedStructureForNodeManagerNavigationModal(
          activeView,
        ),
      );
      store.dispatch(
        updateShowUnsavedStructureForNodeManagerNavigationModal(true),
      );
    }
  };

  public isAlarmProfilesReferenceCopyEqualToAlarmProfiles = () => {
    const alarmProfilesReferenceCopy = getAlarmProfilesReferenceCopy();
    const alarmProfiles = getAlarmProfiles();

    const isItEqual = alarmProfiles.isEqualTo(alarmProfilesReferenceCopy);

    return isItEqual;
  };

  private checkIfAlarmProfilesReferenceCopyIsEqualToAlarmProfilesAndOpenModalIfNeeded =
    (activeView) => {
      if (
        activeView !== "conditionMonitoring" &&
        !this.isAlarmProfilesReferenceCopyEqualToAlarmProfiles()
      ) {
        store.dispatch(
          updateShowUnsavedConditionMonitoringForNodeManagerNavigationModal(
            true,
          ),
        );
        store.dispatch(
          updateActiveViewUnsavedConditionMonitoringForNodeManagerNavigationModal(
            activeView,
          ),
        );
        return true;
      }
      return false;
    };

  public switchNodeManagerActiveViewOnClick = (
    activeView: NodeManagerActiveViewType,
  ) => {
    if (
      this.checkIfAlarmProfilesReferenceCopyIsEqualToAlarmProfilesAndOpenModalIfNeeded(
        activeView,
      )
    ) {
      return;
    }
    this.flushAlarmRowSidePanelInfo();

    if (activeView !== "treeStructure") {
      this.checkIfStructureIsSavedOrEmptyAndNavigateOrOpenUnsavedStructureModal(
        activeView,
      );
    } else {
      store.dispatch(updateNodeManagerActiveView(activeView));
    }
  };

  /** back to sources list End */
}
